import { RootState } from '@/store/store';
import { createSelector } from '@reduxjs/toolkit';
import { HistoryItem } from '@/store/types/historyResultTypes';
import { GenericState } from '@/store/reducers/sliceTemplate';

export const selectHistory = (state: RootState): GenericState<HistoryItem> => state.historyResult;

export const selectHistoryItems = createSelector(
	[selectHistory],
	(historyResultState: GenericState<HistoryItem>) => historyResultState.data
);
